/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultHub } from '../../models/api-response-paged-result-hub';
import { PagedRequestHub } from '../../models/paged-request-hub';

export interface SearchHubs$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestHub
}

export function searchHubs(http: HttpClient, rootUrl: string, params: SearchHubs$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultHub>> {
  const rb = new RequestBuilder(rootUrl, searchHubs.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultHub>;
    })
  );
}

searchHubs.PATH = '/v1/api/hubs/search';
